module.exports = __webpack_public_path__ + "static/media/clue-1.082c5b92.svg";